import React from 'react';
import moment from 'moment';
import { DmsTextField } from 'dmsbasereact';
import { Grid, Typography, Box, Divider } from '@mui/material';
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import "moment/locale/pt-br";

export const DateSection = ({
    isCheckin,
    receivedAt,
    sentAt,
    setReceivedAt,
    setSentAt,
    intl,
}) => {
    return (
        <Box sx={{ mt: 5 }}>
            <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 2 }}>
                {isCheckin ? intl.get('ReceptionDate').d('Reception Date') : intl.get('ShippingDate').d('Shipping Date')}
            </Typography>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                    <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="pt-br">
                        <DateTimePicker
                            label={isCheckin ? intl.get('ReceivedAt').d('Received At') : intl.get('SentAt').d('Sent At')}
                            value={isCheckin ? receivedAt : sentAt}
                            onChange={(newValue) => isCheckin ? setReceivedAt(newValue) : setSentAt(newValue)}
                            renderInput={(params) => <DmsTextField {...params} fullWidth />}
                            format="DD/MM/YYYY HH:mm"
                            maxDateTime={isCheckin ? undefined : moment()}
                        />
                    </LocalizationProvider>
                </Grid>
            </Grid>
            <Divider sx={{ mt: 3 }} />
        </Box>
    );
};
